


























import Vue from 'vue';
import Component from 'vue-class-component';
import alarm from '@/store/modules/alarm';
import { Prop } from 'vue-property-decorator';
import AlarmTool from '../components/alarm/alarm-tool.vue';
import AlarmTable from '../components/alarm/alarm-table.vue';
import { State, Action, Getter } from 'vuex-class';

@Component({
  components: { AlarmTool, AlarmTable },
})
export default class Alarm extends Vue {
  @State('rocketAlarm') private rocketAlarm!: any;
  @Getter('durationTime') private durationTime: any;
  @Prop({default: {label: 'All', key: ''}})
  private alarmScope: any;
  @Prop({default: false, type: Boolean})
  private inTopo!: boolean;
  @Prop({default: ''})
  private keyword!: string;
  private beforeCreate() {
    this.$store.registerModule('rocketAlarm', alarm);
  }
  private beforeDestroy() {
    this.$store.unregisterModule('rocketAlarm');

  }
}
